import React, { useState, useEffect } from "react";
import LineBox from "../../../DefaultStyles/LineBox";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import { useApi } from "../../../../hooks/useApi";
import { authType } from "../../../../pages/Login";
import { useRecoilValue } from "recoil";
import { toast } from "react-toastify";
import Loader from "../../../DefaultStyles/Loader";
import UplusDataUploadInfoFilter from "./UplusDataUploadInfo/UplusDataUploadInfoFilter";
import { getThousandComma } from "../../../../ApiTS/ApiCommonTS";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import Pagination from "../../../Table/Pagination";
import { TotalCount } from "../../../../pages/Users/UserInfo";
import dayjs from "dayjs";

interface IUplusLog {
  id: number;
  total: number;
  success: number;
  fail: number;
  updater: string;
  date: string;
}

export default function UplusDataUploadInfo() {
  const auth = useRecoilValue(authType);

  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState({
    startdate: "",
    enddate: "",
  });

  const { response, loading, error } = useApi({
    method: "get",
    url: auth?.uplus
      ? `uplus2/log?page=${page}&size=10` +
        (filter?.enddate !== ""
          ? `&startdate=${filter?.startdate}&enddate=${dayjs(filter?.enddate)
              .add(1, "d")
              .format("YYYY-MM-DD")}`
          : ``)
      : undefined,
  });

  const tableHead = [
    "Index",
    "업로드 일시",
    "총 업로드 건수",
    "성공",
    "실패",
    "담당자",
  ];

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ??
          "유플러스 데이터 업로드 내역을 불러오는 데에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      <UplusDataUploadInfoFilter
        pageResetEvent={() => setPage(0)}
        setFilter={setFilter}
      />

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {response?.data?.items?.map((d: IUplusLog) => (
              <TableBody key={d?.id}>
                <TableBodyItem>{d?.id}</TableBodyItem>
                <TableBodyItem>{d?.date}</TableBodyItem>
                <TableBodyItem>
                  {getThousandComma(d?.total ?? 0)}건
                </TableBodyItem>
                <TableBodyItem>
                  {getThousandComma(d?.success ?? 0)}건
                </TableBodyItem>
                <TableBodyItem>
                  {getThousandComma(d?.fail ?? 0)}건
                </TableBodyItem>
                <TableBodyItem>{d?.updater}</TableBodyItem>
              </TableBody>
            ))}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response?.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {loading && <Loader />}
    </>
  );
}
